<template>
  <div class="main-body" :style='"height:"+(th+115)+"px"'>
<!--    <div class="header">科室绩效</div>-->
    <div class="out">

      <div class="search2">

        <div style="float:right;">

          <el-select v-model="dateStr" clearable placeholder="请选择时间点" style="margin-right: 5px;">
            <el-option
                v-for="item in dateList"
                :key="item.dateStr"
                :label="item.dateStr"
                :value="item.dateStr">
            </el-option>
          </el-select>

          <el-button size="mini" type="primary" plain icon="el-icon-search" @click="getList">搜索</el-button>
        </div>
        <div style="clear: both;"></div>
      </div>


      <el-table class="table" size="mini" v-loading="loading" :data="tableData" :height="th" border>
        <el-table-column prop="departmentClassName" label="科室分类" width="100"></el-table-column>
        <el-table-column prop="departmentName" label="科室" width="100"></el-table-column>
        <el-table-column prop="dateStr" label="时间点" width="100"></el-table-column>
        <el-table-column prop="totalIn" label="收入" width="150"></el-table-column>
        <el-table-column prop="totalOut" label="支出" width="150"></el-table-column>
        <el-table-column prop="gain" label="收支差额" width="150"></el-table-column>
        <el-table-column prop="merits" label="收支绩效"></el-table-column>

        <el-table-column prop="gain" :formatter="getMeritsTwo" label="奖金二次分配"></el-table-column>


<!--        <el-table-column fixed="right" label="操作" width="200">-->
<!--          <template slot-scope="scope">-->
<!--            <el-button size="mini" plain @click="handleInfo(scope.$index, scope.row)">收支数据</el-button>-->
<!--            <el-button size="mini" type="danger" plain @click="handleDelete(scope.$index, scope.row)">删除</el-button>-->
<!--          </template>-->
<!--        </el-table-column>-->

      </el-table>
      <div class="page">
        <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
        <div style="float: left;">
          <el-pagination small
                         background
                         layout="prev, pager, next"
                         :total="totalItems"
                         :page-size="20"
                         :current-page.sync="currentPage"  @current-change="current_change">
          </el-pagination>
        </div>
        <div style="clear: both;"></div>
      </div>


    </div>

    <Info ref="myInfo" v-show="showModalInfo" v-on:closeInfo="closeInfo" v-on:getList="getList"></Info>
    <Department ref="myDepartment" v-show="showModalDepartment"
                v-on:closeDepartment="showModalDepartment=false"
                v-on:setDepartment="setDepartment"
                v-on:setDepartment2="setDepartment2"></Department>

  </div>
</template>

<script>

import Info from "./Info";
import Department from "./Department";

import {getStaffCode,getGovernmentCode} from "@/utils/auth";
import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";

export default {
  name: "Page",
  activated() {

    let topTabs = this.$store.state.topTabs;
    if(topTabs && topTabs.length>0){
      let path = this.$route.path;
      let index = topTabs.findIndex(item => item === path);
      if(index ==-1){
        this.init();
      }
    }
    else{
     this.init();
    }


    let topTabs1 = this.$store.state.topTabs;
    if(topTabs1 == null){
      topTabs1 = [];
      topTabs1.push(this.$route.path);
      this.$store.commit('update', ['topTabs',topTabs1]);
    }
    else{
      let index = topTabs.findIndex(item => item === this.$route.path);
      if(index ==-1){
        topTabs1.push(this.$route.path);
        this.$store.commit('update', ['topTabs',topTabs1]);
      }
    }


  },
  deactivated() {
    //console.log("JobClass停用");
  },


  data(){
    return{

      loading:false,

      departmentCode:'',
      dateStr:'',

      tableData:[],
      totalItems: 0,
      pageSize:20,
      currentPage:1,

      showModalInfo:false,
      showModalResult:false,

      th:0,

      arr : [],


      departmentList:[],
      dateList:[],

      showModalDepartment:false,

    }
  },
  created(){
    this.th = this.$store.state.tableHeight;
  },
  components:{
    Info,Department
  },
  watch: {
    //监听全局变量
    '$store.state.tableHeight' : function(val){
      this.th = val;
    },
  },
  methods:{

    init(){
      this.getDateList();
      this.getList();
    },

    getDateList(){
      this.$axios({
        method: 'post',
        url: this.$shopUrl+'DepartmentInOutData/GovListDate',
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          governmentCode:getGovernmentCode(),
        }
      }).then( (response)=> {
        //console.log(response);
        if(response.data.error == 0){
          this.dateList = response.data.data.list;
        }else if(response.data.error == 1){
          this.$message(response.data.message);
        }else{
          console.log(response.data.message);
        }

      }).catch(function (error) {
        console.log(error);
      });
    },



    handleInfo(index, row) {
      this.$refs.myInfo.init(row);
      this.showModalInfo = !this.showModalInfo;
    },
    closeInfo:function(){
      this.showModalInfo = !this.showModalInfo;
    },


    getMeritsTwo(row,col,val){
      //console.log(row,col,val);

      let m = 0;
      if(row.listDepartmentGainTwo != null && row.listDepartmentGainTwo.length>0){
        for(let i=0;i<row.listDepartmentGainTwo.length;i++){
          m += row.listDepartmentGainTwo[i].merits;
        }
      }
      return m;
    },


    search(){
      this.currentPage = 1;
      this.getList();
    },
    current_change:function(currentPage){
      this.currentPage = currentPage;
      this.getList();
    },
    getList(){
      this.loading = true;
      this.$axios({
        method: 'post',
        url: this.$shopUrl+'DepartmentGain/GovPage',
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          governmentCode:getGovernmentCode(),
          pageIndex: this.currentPage,
          pageSize: this.pageSize,
          dateStr:this.dateStr,
        }
      }).then( (response)=> {
        //console.log(response);
        this.loading = false;
        if(response.data.error == 0){
          this.tableData = response.data.data.pageInfo.list;
          this.totalItems = response.data.data.pageInfo.total;
        }else if(response.data.error == 1){
          this.$message(response.data.message);
        }else{
          console.log(response.data.message);
        }

      }).catch(function (error) {
        console.log(error);
      });
    },



  }
}
</script>

